module.exports = __webpack_public_path__ + "images/feature/20190618-107548914ca500e68e484541df80e329.png";